<script>
import {router, useForm} from "@inertiajs/vue3";
import Card from "@/pages/components/card.vue";
import UpdateForm from "@wielink-application/shared/js/mixins/updateForm";
import Modal from "@/pages/components/modal.vue";
import Signature from "@/pages/components/form/input-only/signature.vue";

const requireComponent = require.context("@/pages/inspection_reports/form-sections/", false, /\w+\.(vue|js)$/);
let components = {};
for (let fileName of requireComponent.keys()) {
	let name = fileName.split("/").pop().split(".")[0];
	components[name] = requireComponent(fileName).default;
}

let timeout = null;

export default {
	components: {
		...components,
		Card,
		Modal,
		Signature
	},

	mixins: [UpdateForm],

	data() {
		return {
			groups: {},
			form: {errors: {}},
			showSuccessMessage: false,
			stayOnPage: true
		}
	},

	props: {
		customerProduct: {
			required: true,
			type: Object
		},
		inspectionReport: {
			required: true,
			type: Object
		},
		inspectionReportResponse: {
			required: false,
			type: Object
		},
		appointmentId: {
			required: true,
		}
	},

	mounted() {
		this.formRoute = route('api.v1.inspection_report_responses.update', {inspectionReportResponse: this.inspectionReportResponse.id});
		this.redirectRoute = route('inspection_reports.index', {appointment: this.appointmentId});
	},

	methods: {
		setGroups(groups) {
			this.groups = groups;

			let form = {
				values: {}
			};

			this.groups.forEach((group) => {
				for (let name in group.values) {
					form['values'][name] = {
						name: name,
						group: group.title ?? group.name,
						label: group.values[name].label,
						type: group.values[name].type,
						value: group.values[name].value,
						option: group.values[name].option
					}
				}
			});

			form.revision = this.inspectionReportResponse.revision;
			form.inspection_report_id = this.inspectionReport.id;
			form.product_id = this.customerProduct.product_id;
			form.appointment_id = this.appointmentId;
			form.signature = this.inspectionReportResponse.signature;
			form.is_concept = 1;

			this.form = useForm(form);
		},

		updateForm(info) {
      if(info.type == 'option') {
        this.form['values'][info.input]['option'] = info.option
        this.groups.filter(group => group.name === info.group)[0]['values'][info.input]['option'] = info.option;
      } else {
        this.form['values'][info.input]['value'] = info.value
        this.groups.filter(group => group.name === info.group)[0]['values'][info.input]['value'] = info.value;
      }

			timeout ? clearTimeout(timeout) : null;
			timeout = setTimeout(() => {
				this.submit();
			}, 200);
		},

		async onSuccess(form, response) {
			if (this.stayOnPage) {
				return;
			}

			router.get(this.redirectRoute, {
				'success': 'Het formulier is opgeslagen'
			});
		},

		submitSignature() {
			this.stayOnPage = false;
			this.form.is_concept = 0;
			this.submit();
		},
	}
}
</script>

<template>
	<form id="inspection_form" @submit.prevent="submitSignature">
		<div class="alert alert-warning  mb-4">
			<div class="text">
				<p>
					<strong>
						<i>Let op! dit formulier wordt tussentijds automatisch opgeslagen</i>
					</strong>
				</p>
			</div>
		</div>

		<div class="row g-4 mb-4">
			<component v-for="(group, index) in this.groups" :key="'group-' + index" :is="group.component" :group="group" @update:form="updateForm"/>
		</div>
	</form>
</template>